import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EntryNoteAssociationService {

  private URL = environment.api + "api/erp/entry-notes/associations";

  constructor(private http: HttpClient) { }

  associateEntryNoteToOrder(entryNoteId: number, orderId: number) {
    return this.http.post(this.URL + `/purchase-orders`, {
      entryNoteId: entryNoteId,
      orderId: orderId
    });
  }
  
  associateEntryNoteToInvoice(entryNoteId: number, orderId: number) {
    return this.http.post(this.URL + `/provider-invoices`, {
      entryNoteId: entryNoteId,
      invoiceId: orderId
    });
  }

  // getRelatedOrderByEntryNote(entryNoteId: number) {
  //   return this.http.get(this.URL + `/${entryNoteId}/order`);
  // }

  // setRelationEntryNoteOrder(entryNoteId: number, orderId: number) {
  //   return this.http.put(this.URL + `/${entryNoteId}/order/${orderId}`, {});
  // }

  removeAssociationEntryNoteToOrder(entryNoteId: number) {
    return this.http.delete(this.URL + `/purchase-orders/${entryNoteId}`);
  }

}
